window.app = window.app || {};
app.site = app.site || {};

app.site.header = () => {

    const content = document.querySelector('div#top');
    const header  = document.querySelector('header.site');

    const observerOptions = {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0
    };
    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                header.classList.remove('is-dropping');
            } else {
                header.classList.add('is-dropping');
            }
        });
    };
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    observer.observe(content);


};